var render = function render(){var _vm=this,_c=_vm._self._c;return _c('travel-restrictions-list',{attrs:{"travelRestrictions":_vm.data,"travelRestrictionsLoading":_vm.entityLoading,"totalTravelRestictions":_vm.totalCount},on:{"loadData":function($event){return _vm.loadData($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }